import { MainPageConfigType } from '@@partner:types:app'

export const MAIN_PAGE_CONFIG_TYPE_OPTIONS: Array<{
  value: MainPageConfigType
  label: string
}> = [
  { value: 'delivery', label: 'Доставка' },
  { value: 'shop', label: 'Магазины' },
  { value: 'wholesale', label: 'Опт' }
]

export const MAIN_PAGE_CONFIG_TYPE_LABELS: Record<MainPageConfigType, string> =
  MAIN_PAGE_CONFIG_TYPE_OPTIONS.reduce((acc, option) => {
    acc[option.value] = option.label
    return acc
  }, {} as Record<MainPageConfigType, string>)


